module.exports = __webpack_public_path__ + "img/1440.21451b46.jpg";